import * as logger from "./logger";
import Notifications from "./notifications";
import { updateAppCache } from "./appcache";
import { UserService } from "./users";

export function startAppCacheListeners(userService: UserService) {
    let notificationKey = "appCache";

    let logAppCacheEvent = (evt) => {
        if (evt.type === "error") {
            logger.error(logger.Source.APPCACHE, `Error: ${ evt.message }`);
        } else {
            logger.log(logger.Source.APPCACHE, evt.type);
        }
    };

    let onAppCacheUpdateError = () => {
        if (window.applicationCache && window.applicationCache.status === window.applicationCache.UNCACHED) {
            logger.error(logger.Source.APPCACHE, `AppCache reload status=UNCACHED`);
            window.location.reload();
            return;
        }
        updateAppCache();
    };

    let handleAppCacheError = () => {
        let user = userService.getCurrentUser();

        user && Notifications.add(notificationKey, {
            type: "app",
            message: "Problem updating app. Tap here to retry.",
            critical: true,
            action: onAppCacheUpdateError
        }, user.id);
    };

    let handleAppCacheUpdated = (evt) => {
        let user = userService.getCurrentUser();
        user && Notifications.remove(notificationKey, user.id);
        logAppCacheEvent(evt);
    };

    if (window.applicationCache) {
        window.applicationCache.removeEventListener("error", window.appcacheInitErrorHandler, false);
        window.applicationCache.addEventListener("error", handleAppCacheError, false);

        window.applicationCache.addEventListener("error", logAppCacheEvent, false);
        window.applicationCache.addEventListener("cached", handleAppCacheUpdated, false);
        window.applicationCache.addEventListener("checking", logAppCacheEvent, false);
        window.applicationCache.addEventListener("downloading", logAppCacheEvent, false);
        window.applicationCache.addEventListener("noupdate", handleAppCacheUpdated, false);
        window.applicationCache.addEventListener("obsolete", logAppCacheEvent, false);
        window.applicationCache.addEventListener("updateready", handleAppCacheUpdated, false);
    }
}